import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import Invoice from "../components/Invoice";
import Toast from "../../../../../components/common/toast/Toast";

import * as invoiceActions from "./../../../../../actions/invoice.actions";
import * as commonActions from "./../../../../../actions/common.actions";
import * as userActions from "./../../../../../actions/user.actions";
import { Mixpanel } from "../../../../../actions/mixpanel.actions";

const subHeader = {
  items: [
    {
      caption: "Matches",
      url: "/member/projects/matches"
    },
    {
      caption: "Pitches",
      url: "/member/projects/pitches"
    },
    {
      caption: "SOWs",
      url: "/member/projects/sows"
    },
    {
      caption: "Completed",
      url: "/member/projects/completed"
    },
    {
      caption: "Invoices",
      url: "/member/projects/invoices"
    }
  ],
  activeItem: 4,
  track: true
};

class InvoiceContainer extends Component {
  constructor(props) {
    super(props);

    this.downloadInvoice = this.downloadInvoice.bind(this);
    this.removeInvoice = this.removeInvoice.bind(this);
  }

  componentDidMount() {
    this.props.commonActions.setSubHeader(subHeader);
    this.props.invoiceActions.getInvoices();

    if (_.isEmpty(this.props.stats)) {
      this.props.userActions.getUserStats(4);
    }

    if (_.get(this.props, "location.state.showToast") === true) {
      this.toast.showToast(this.onToastClose);
    }
  }

  componentWillUnmount() {
    this.props.commonActions.setSubHeader({});
  }

  downloadInvoice(invoiceId) {
    this.props.invoiceActions.downloadInvoice(invoiceId);
    Mixpanel.track("Member - Invoices - Download Invoice");
  }

  removeInvoice(invoiceId) {
    this.props.invoiceActions.removeInvoice(invoiceId);
    Mixpanel.track("Member - Invoices - Invoice Removed");
  }

  render() {
    return (
      this.props.invoices && (
        <React.Fragment>
          <Toast
            onRef={ref => (this.toast = ref)}
            title="Success!"
            content="We have received your invoice."
          />
          <Invoice
            invoices={this.props.invoices}
            downloadInvoice={this.downloadInvoice}
            removeInvoice={this.removeInvoice}
          />
        </React.Fragment>
      )
    );
  }
}

const mapStateToProps = state => {
  return {
    invoices: state.invoice.invoices,
    stats: state.user.stats
  };
};

const mapDispatchToProps = dispatch => {
  return {
    invoiceActions: bindActionCreators(invoiceActions, dispatch),
    commonActions: bindActionCreators(commonActions, dispatch),
    userActions: bindActionCreators(userActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InvoiceContainer);



// WEBPACK FOOTER //
// ./src/routes/candidate/projects/invoice/containers/InvoiceContainer.js